export default __webpack_public_path__ + "static/media/778.84da654b.gif";